import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import { useAppSelector } from "../../redux/store/hooks"
import {
    selectDashboardSelectedPatient,
    selectMedicationRisks,
    selectMedicationTimestamp
} from "../../redux/ProfessionalDashboard"
import MedicationRisksComponent from "../MedicationRiskComponent"
import {
    MedicationIndicatorGroup, MedicationIndicatorGroupEntries, medicationIndicatorGroupList,
    MedicationIndicatorNames,
    MedicationRisk, medicationRiskGroupBelongsToTherapyRisks,
    overMedicationIndicatorGroups,
    SortedRisks,
    sortRisks
} from "pokal_api"
import { useEffect, useState } from "react"
import notNull from "../../util/notNull"
import SmallestHeadingComponent from "../SmallestHeadingComponent"

function MedicationRisksView() {
    const risks = useAppSelector(selectMedicationRisks)
    const patient = useAppSelector(selectDashboardSelectedPatient)
    const selectedTimestamp = useAppSelector(selectMedicationTimestamp)

    const [viewedRisks, setViewedRisks] = useState<SortedRisks | null>(null)

    function sortRisks(medicationRisks: MedicationRisk[]): SortedRisks {
        const overMedicationRisks: { group: MedicationIndicatorGroup, items: MedicationRisk[] }[] = []
        const therapyRisks: { group: MedicationIndicatorGroup, items: MedicationRisk[] }[] = []
        for(const group of medicationIndicatorGroupList) {
            const items: MedicationRisk[] = medicationRisks.filter(r => MedicationIndicatorNames[r.indicator].group === group)
            const sorted = items.sort((s1, s2) => MedicationIndicatorNames[s1.indicator].priority - MedicationIndicatorNames[s2.indicator].priority)
            if (medicationRiskGroupBelongsToTherapyRisks(group)) {
                therapyRisks.push({
                    group: MedicationIndicatorGroupEntries[group], items: sorted
                })
            } else {
                overMedicationRisks.push({
                    group: MedicationIndicatorGroupEntries[group], items: sorted
                })
            }
        }
        const sortedOverMedicationRisks = overMedicationRisks.sort((s1, s2) => s1.group.priority - s2.group.priority)
        const sortedTherapyRisks = therapyRisks.sort((s1, s2) => s1.group.priority - s2.group.priority)
        return {
            overMedicationRisks: sortedOverMedicationRisks,
            therapyRisks: sortedTherapyRisks
        }
    }

    useEffect(() => {
        if (notNull(risks)) {
            const sorted = sortRisks(risks[selectedTimestamp].indicators)
            console.log(risks)
            console.log(sorted)
            setViewedRisks(sorted)
        }
    }, [risks, selectedTimestamp])

    return (
        <Card width={"100%"}>
            <div className={"flex flex-col space-y-4"}>
                <SmallHeadingComponent>Risiken</SmallHeadingComponent>
                {patient === null || risks === null || viewedRisks === null ? (
                    <div className={"italic"}>
                        Risiken konnten nicht geladen werden. Bitte wählen Sie
                        eine Patient:in aus.
                    </div>
                ) : (
                    <div className={"flex space-x-4"}>
                        <div className={"flex-1 flex-col space-y-4"}>
                            <SmallestHeadingComponent>
                                Übermedikation
                            </SmallestHeadingComponent>
                            {viewedRisks.overMedicationRisks.filter(g => g.items.length > 0).map((group) => (
                                <div key={group.group.priority} className={"flex flex-col space-y-4"}>
                                    {group.group.name && <div className={"font-bold"}>{group.group.name}</div>}
                                    {group.items.map(i => (
                                        <MedicationRisksComponent key={i.indicator} risk={i} />
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div className={"flex-1 flex-col space-y-4"}>
                            <SmallestHeadingComponent>
                                Therapierisiken
                            </SmallestHeadingComponent>
                            {viewedRisks.therapyRisks.filter(g => g.items.length > 0).map((group) => (
                                <div key={group.group.priority} className={"flex flex-col space-y-4"}>
                                    {group.group.name && <div className={"font-bold"}>{group.group.name}</div>}
                                    {group.items.map(i => (
                                        <MedicationRisksComponent key={i.indicator} risk={i} />
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </Card>
    )
}

export default MedicationRisksView
